// We need all clients to know Element.matches for formbouncer.js
// See https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
import 'element-matches-polyfill'

// Bouncer cannot be required using `import` as it is a CommonJS module
const Bouncer = require('formbouncerjs/dist/bouncer');

const trimWhiteSpace = (event) => {
  const target = event.target;
  const contents = target.value;
  const trimmedContents = contents.trim().replace(/\s+/g, ' ');

  target.value = trimmedContents;
  return true;
};

export const trimInputs = (inputElements) => {
  inputElements.forEach((input) => {
    input.addEventListener('blur', trimWhiteSpace)
  });
}

export const validateInputs = (inputElements, formSelector = 'form') => {
  const validator = new Bouncer(formSelector);
  inputElements.forEach((input) => {
    input.addEventListener('blur', (event) => {
      validator.validate(event.target);
    });
  });
}
